module.exports = __webpack_public_path__ + "static/img/moaVersionView_pic01.f671fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaVersionView/moaVersionView_pic01.png
// module id = 549
// module chunks = 1